export interface DatabaseTableInterface {
  tablename: string;
  description: string;
}

export class DatablaseTableClass implements DatabaseTableInterface {
  tablename: string;
  description: string;

}
